/** Recovery-specific restore never substitutes another variant or trusts snapshot prices/stock. */
export function selectRecoveryVariant<T extends { id: string; availableForSale?: boolean }>(
  variants: T[], requestedId: string,
): T | null {
  const variant = variants.find((candidate) => candidate.id === requestedId);
  return variant?.availableForSale === true ? variant : null;
}
export function isAccountRecoveryDestination(search: string): boolean {
  return new URLSearchParams(search).get("recovery") === "account";
}
export function recoveryEpisodeId(search: string): string | null {
  const id = new URLSearchParams(search).get("episode");
  return id && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id) ? id : null;
}